import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals";
import LaddaButton from "../../../components/buttons/laddaButton";
import SimpleSelect from "../../../components/selects/simpleSelect";
import AddProtocolActivity from "../modals/addProtocolActivity";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid } from "@mui/material";
import {
  callActionApiAsync,
  postSaveBiomedicalEquipmentModelInspectionProtocol
} from "../../../services/apiService";
import ToastNotification from "../../../components/toastNotification";
import { icons } from "../../../constants";

const validationSchema = yup.object({
  activityId: yup
    .number()
    .typeError("La actividad es obligatoria")
    .required("La actividad es obligatoria")
});

const ModelInspectionProtocolModal = ({
  open,
  close,
  modelId,
  userId,
  activityOptions,
  reloadActivityOptions,
  selectedRow,
  onSaved,
  isViewer
}) => {
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "warn",
    summary: "",
    detail: ""
  });
  const [openAddActivityModal, setOpenAddActivityModal] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      activityId: ""
    }
  });

  useEffect(() => {
    if (!open) return;
    reset({
      activityId: selectedRow?.activityId ? Number(selectedRow.activityId) : ""
    });
  }, [open, reset, selectedRow]);

  const handleClose = () => {
    reset({ activityId: "" });
    close();
  };

  const onSubmit = async (formData) => {
    await callActionApiAsync(
      () =>
        postSaveBiomedicalEquipmentModelInspectionProtocol({
          id: selectedRow?.id || 0,
          userId,
          modelId,
          activityId: formData.activityId
        }),
      () => {
        onSaved?.();
        handleClose();
      },
      (error) => {
        setToastConfig({
          severity: "error",
          summary: "Protocolo por modelo",
          detail:
            typeof error === "string" && error
              ? error
              : selectedRow
                ? "No se pudo actualizar la actividad del modelo."
                : "No se pudo agregar la actividad al modelo."
        });
        setShowToast(true);
      }
    );
  };

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title={
          selectedRow
            ? "Editar actividad del protocolo del modelo"
            : "Agregar actividad al protocolo del modelo"
        }
        actions={<div className="HContainer j-center w-complete mt-10"></div>}
        maxWidth="780px"
      >
        <ToastNotification
          showToast={showToast}
          setShowToast={setShowToast}
          severity={toastConfig.severity}
          summary={toastConfig.summary}
          detail={toastConfig.detail}
        />

        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={1}>
            <Grid item xs={10.5} md={10.5}>
              <p className="create-label">Actividad:</p>
              <SimpleSelect
                name="activityId"
                control={control}
                options={activityOptions}
                hideLabel
                error={errors.activityId}
                margin={"0"}
                disabled={isViewer}
              />
            </Grid>
            <Grid item xs={1.5} md={1.5} className="VContainer align-end">
              <LaddaButton
                width={"40px"}
                fontSize={"12px"}
                height={"40px"}
                variant="contained"
                margin={"0"}
                type="button"
                onClick={() => setOpenAddActivityModal(true)}
                disabled={isViewer}
              >
                <img className="btn-icon" src={icons.plusIcon} alt="icon" />
              </LaddaButton>
            </Grid>
            <Grid item xs={12} className="HContainer j-center mt-15">
              <LaddaButton type="submit" variant="contained" disabled={isViewer}>
                {selectedRow ? "Guardar cambios" : "Agregar actividad"}
              </LaddaButton>
            </Grid>
          </Grid>
        </form>

        <AddProtocolActivity
          open={openAddActivityModal}
          close={() => setOpenAddActivityModal(false)}
          getProtocolActivities={reloadActivityOptions}
          userId={userId}
          isViewer={isViewer}
        />
      </ModalComponent>
    </>
  );
};

export default ModelInspectionProtocolModal;
